import React from 'react';
import TestTypeSelector from './TestTypeSelector';
import VariantSelector from './VariantSelector';
import DataInputForm from './DataInputForm';
import StatisticalSettings from './StatisticalSettings';
import ResultsDisplay from './ResultsDisplay';

const CalculatorContent: React.FC = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {/* Input Form */}
      <div className="space-y-6">
        <h2 className="text-xl font-semibold mb-4">Test Configuration</h2>
        
        {/* SECTION 1: Define the actual test */}
        <div className="p-4 bg-gray-50 dark:bg-gray-700/30 rounded-lg space-y-6">
          <h3 className="font-medium">Define Your Experiment</h3>
          <TestTypeSelector />
          <VariantSelector />
        </div>
        
        {/* SECTION 2: Define user input and data */}
        <DataInputForm />
        
        {/* SECTION 3: Fine-tune the sample size calculation */}
        <StatisticalSettings />
      </div>
      
      {/* Results Section */}
      <div className="space-y-6">
        <h2 className="text-xl font-semibold mb-4">Results</h2>
        <ResultsDisplay />
      </div>
    </div>
  );
};

export default CalculatorContent;
